import React from "react";
import { Box, Text, Hidden } from "@origin-digital/ods-core";

interface HelperTextProps {
  text?: string | React.ReactNode;
  children?: React.ReactNode;
}

const HelperText: React.FC<HelperTextProps> = ({ text, children }) => (
  <Box display="flex" alignItems="stretch" height="full">
    <Hidden below="md">
      <Box
        style={{ borderLeft: "1px solid #E3E3E3" }}
        paddingRight="large"
        height="full"
      />
    </Hidden>
    <Box alignSelf="center" marginTop="xsmall">
      {children ? (
        children
      ) : (
        <Text variant="body-small" tone="neutralLight">
          {text}
        </Text>
      )}
    </Box>
  </Box>
);

export default HelperText;
